import { gql } from '@apollo/client';

// Submit art design brief for customer portal
export const SUBMIT_CUSTOMER_ART_BRIEF = gql`
  mutation SubmitCustomerArtBrief($input: SubmitCustomerArtBriefInput!) {
    submitCustomerArtBrief(input: $input) {
      success
      error
      message
      campaignArtId
      campaignArtBriefId
      campaignArtFileIds
      kioskArtLogIds
    }
  }
`;

// Review (approve/reject) art proof for customer portal
export const REVIEW_CUSTOMER_ART_PROOF = gql`
  mutation ReviewCustomerArtProof($campaignArtBriefId: Int!, $isApproved: Boolean!) {
    reviewCustomerArtProof(
      campaignArtBriefId: $campaignArtBriefId
      isApproved: $isApproved
    ) {
      success
      error
      message
      campaignArt {
        id
        campaignId
        installed
        campaignArtBrief {
          id
          headlineText
          phone
          email
          website
        }
      }
    }
  }
`;

// Add art note/comment for customer portal
export const ADD_CUSTOMER_ART_NOTE = gql`
  mutation AddCustomerArtNote($campaignArtFileId: Int!, $note: String!) {
    addCustomerArtNote(
      campaignArtFileId: $campaignArtFileId
      note: $note
    ) {
      id
      campaignArtId
      campaignArtFileId
      note
      createDate
      senderId
      senderTypeId
      senderType {
        id
        typeName
      }
      noteType {
        id
        typeName
      }
    }
  }
`;

// Update art design brief for customer portal
export const UPDATE_CUSTOMER_ART_BRIEF = gql`
  mutation UpdateCustomerArtBrief($input: UpdateCustomerArtBriefInput!) {
    updateCustomerArtBrief(input: $input) {
      id
      campaignId
      headlineText
      phone
      email
      website
      facebook
      instagram
      twitter
      tikTok
      snapchat
      colors
      conceptFileUrl
    }
  }
`;

